import type { Entitlements } from 'core/shared/enums/entitlements.enum';
import type { LicensingStatusAppsResponse } from 'entities/company/company.models';

export const hasEntitlements = (app: LicensingStatusAppsResponse, entitlements: Entitlements[]): boolean => {
  return !!app.plan.entitlements.find(appEntitlement => entitlements.includes(appEntitlement.key));
};
